/** Shared sister-tool links for aixcalculator matrix sites. */
export const TOOL_LINKS = [
  { id: 'ip', name: 'IP Lookup', href: 'https://ip.aixcalculator.com/', blurb: 'Public & local IP' },
  { id: 'sleep', name: 'Sleep Calculator', href: 'https://sleepcalculator.aixcalculator.com/', blurb: 'Best bedtime cycles' },
  { id: 'date', name: 'Date Calculator', href: 'https://datecalculator.aixcalculator.com/', blurb: 'Days between dates' },
  { id: 'currency', name: 'Currency Converter', href: 'https://currencyconverter.aixcalculator.com/', blurb: 'Live FX rates' },
  { id: 'percentage', name: 'Percentage Calculator', href: 'https://percentagecalculator.aixcalculator.com/', blurb: 'Percent math modes' },
  { id: 'iata', name: 'IATA Code', href: 'https://iatacode.aixcalculator.com/', blurb: 'Airport codes' },
  { id: 'utc', name: 'UTC Time', href: 'https://utc.aixcalculator.com/', blurb: 'World clocks' },
  { id: 'game', name: 'Games Hub', href: 'https://game.aixcalculator.com/', blurb: 'Quick browser games' },
  { id: 'emoji', name: 'Emoji Search', href: 'https://emoji.aixcalculator.com/', blurb: 'Search & copy emoji' },
];

export function sisterTools(excludeId) {
  return TOOL_LINKS.filter((t) => t.id !== excludeId);
}
